import React from 'react';

import { Box, Paper, Popper, PopperProps } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

const ARROW_SIZE = 24;

export type FocusedElementTooltipProps = {
  open: boolean;
  topSpacing?: number;
  children: React.ReactElement;
  content: React.ReactNode;
};

const Arrow = () => {
  return (
    <Box
      data-id="arrow"
      width={ARROW_SIZE}
      height={ARROW_SIZE}
      bgcolor="white"
      position="absolute"
      left="50%"
      style={{ transform: 'translateX(-50%) rotateZ(45deg)' }}
    />
  );
};

const useStyles = makeStyles()(theme => ({
  popper: {
    zIndex: theme.zIndex.appBar + 3,
    "&[x-placement*='bottom'] [data-id='arrow']": {
      top: `-${ARROW_SIZE / 2}px`,
    },
    "&[x-placement*='top'] [data-id='arrow']": {
      bottom: `-${ARROW_SIZE / 2}px`,
    }
  },
}));

export const FocusedElementTooltip: React.VFC<FocusedElementTooltipProps> = ({ children, content, open, topSpacing = 0, ...props }) => {
  const { classes } = useStyles();
  const [ anchorEl, setAnchorEl ] = React.useState<PopperProps['anchorEl']>();
  const _children = React.cloneElement(children, { ref: setAnchorEl, ...props });

  return (
    <>
      {_children}
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom"
        className={classes.popper}
      >
        <Box
          component={Paper}
          position="relative"
          marginTop={`${ARROW_SIZE + topSpacing}px`}
          marginBottom={`${ARROW_SIZE + topSpacing}px`}
        >
          <Arrow/>
          {content}
        </Box>
      </Popper>
    </>
  );
};
